import "./TooltipLayout.css";
import "../assets/Asset.css";

interface TooltipItem {
  label: string;
  text: string;
}

interface TooltipLayoutProps {
  title?: string;
  items?: TooltipItem[];
  children?: React.ReactNode;
}

export const TooltipLayout = ({ title, items, children }: TooltipLayoutProps) => (
  <div className="pr-1">
    {title && <h6 className="mb-1 px-2 py-0 text-white fw-bold">{title}</h6>}
    {items && items.length > 0 ? (
      <table className="network-element-tooltip-table">
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td className="px-2 py-1">
                <span className="text-white">{item.label} :</span>
              </td>
              <td className="px-2 py-1">
                <span className="text-white">{item.text}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : null}
    {children}
  </div>
);

export default TooltipLayout;
